import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem, sectionStyle } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc113 = {
    title: "Image 113: Example of a Boom Barrier.",
    para1: "The image shows a red and white traffic barrier bar on a road. A boom barrier is used to control the traffic in a particular area. The barries is supported on an orange stand that acts as a hinge to control the movement of the barrier. ",
}

export const ImageDesc114 = {
    title: "Image 114: Example of a Door Frame Metal Detector.",
    para1: "The image shows a black metal detector. The metal detector has a screen on top of it which beeps and gives a signal regarding any metal items that may be transported through it. Metal detectors are also used to keep a count of people entering a particular building to ensure safe evacuation at the time of emergencies. ",
}

export const ImageDesc115 = {
    title: "Image 115: Example of a Full Body Scanner. ",
    para1: "The image shows a full body scanner. The scanner is used to scan persons entering the premises of a building to detect objects on or inside a person's body for security screening purposes, without physically removing clothes or making physical contact.",
}

export const ImageDesc116 = {
    title: "Image 116: Example of a Baggage Scanner.",
    para1: "The image shows a metal detector with a monitor on top of it. A baggage detector is used to scan and inspect all bags and packages entering the premises of a building for security purposes.",
}

export const ImageDesc117 = {
    title: "Image 117: Example of a Turnstile. ",
    para1: "The image shows a tripod turnstile. The turnstile has three rotating arms that allows one person to pass through at a time and enter the premises of a building. Turnstiles are also used to keep a count of people entering a particular building to ensure safe evacuation at the time of emergencies. ",
}

export const ImageDesc118 = {
    title: "Image 118: Example of a Bollard & Burried Vehicle Barriers.",
    para1: "The image shows a yellow and black striped road blocker and vehicle barriers on a street. The bollard helps control the entry or exit of vehicles into the building premises at the time of an emergency or a security breach. When not in use, the bollard is lowered into the road and is not visible over the surface of the same. ",
}

export const ImageDesc119 = {
    title: "Image 119: Example of a Mobile Sniffer.",
    para1: "The image shows a metallic mobile sniffer. A Mobile Sniffer is a futuristic system of sniffing explosive materials based on chemical signatures which mimics the natural ability of canines.",
}

export const ImageDesc120 = {
    title: "Image 120: Representation of an Emergency Communication & Evacuation System. ",
    para1: <>
        <p>The image shows the representation of an Emergency Communication and Evacuation System with the following components:</p>
        <div className="figure_desc">
            {generateUnOrderedList([
                "The LAN/WAN system that connects all parts of the communication and evacuation system- This is the local area network (LAN) or wide area network (WAN) that the system is connected to.",
                "SIP Phones (wired or wireless)- These can be wired or wireless, and they are used to make and receive calls over the internet.",
                "Barix Annuncicom 100 which connects to a mic and a sound system to make announcements and can be used to control access to certain parts of the premises-  This is an IP audio endpoint device.",
                "PBX Server- This is a private branch exchange, which is a telephone switching system used in an enterprise. The image shows two possible server options: Cisco Call Manager and Asterisk SIP Server.",
                "Barix Instreamer 100: This is another IP audio endpoint device. The Background Music Source, which is the source of the background music that can be played through the system, may be connected to this.",
                "Barix Exstreamer 200: This is yet another IP audio endpoint device.",
                "Barix Barionet: This appears to be the software that is used to manage the Barix devices on the network. This is further connected to the Motion Sensor, Panic Button, Alarm System and Door Locks. ",
            ])}
        </div>
    </>,
}

export const ImageDesc121 = {
    title: "Image 121: Representation of a Parking Management System. ",
    para1: <>
        <p>The image shows an example of a central parking system. The image shows a red and white traffic barrier bar on a road. A boom barrier is used to control the traffic in a particular area. The barrier is supported on an orange stand that acts as a hinge to control the movement of the barrier. </p>
        <p>The management system further has the following components:
            <div className="figure_desc">
                {generateUnOrderedList([
                    <><span style={sectionStyle}>Central Management System (CMS): </span>
                        This is the brain of the system, managing all the other components.
                    </>,
                    <><span style={sectionStyle}>CCTV: </span>
                        This refers to closed-circuit television, which is a video surveillance system typically used for security purposes.
                    </>,
                    <><span style={sectionStyle}>Cashier Station: </span>
                        This is a booth where a person can pay for parking.
                    </>,
                    <><span style={sectionStyle}>Parking Barrier:</span>
                        This is a device that regulates entry and exit from a parking lot. It can be raised or lowered to allow cars to pass.
                    </>,
                    <><span style={sectionStyle}>Exit Station: </span>
                        This is where vehicles exit the parking lot. It likely has a mechanism to read license plates or parking tickets and raise the barrier accordingly.
                    </>,
                    <><span style={sectionStyle}>Entry Station: </span>
                        This is where vehicles enter the parking lot. It likely has a mechanism to dispense parking tickets or allow entry for authorised vehicles.
                    </>,
                    <><span style={sectionStyle}>Automatic Pay Station: </span>
                        This is a kiosk where drivers can pay for parking with cash, credit card, or debit card.
                    </>,
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc122 = {
    title: "Image 122: Representation of a Visitor Management System. ",
    para1: <>
        <p>The image shows a visitor management system (VMS) with the following components:
            <p><b>Visitor Arrival</b>
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "After aarrival at the Guard’s table, the diagram shows two paths for visitors: new visitors and previously registered visitors.",
                        <><b>New Visitor: </b>A new visitor would provide their details to the guard.</>,
                        <><b>Previously Registered Visitor: </b>A previously registered visitor would look up their record with the guard.
                        </>,
                    ])}
                </div>
            </p>

            <p><b>Visitor Check-in</b>
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The guard would then collect the visitor's details and issue a visitor pass.",
                    ])}
                </div>
            </p>

            <p><b>Visitor on-site</b>
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The visitor would then meet the person they are visiting at their designated location.",
                    ])}
                </div>
            </p>

            <p><b>Visitor Check-out</b>
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Once the visit is complete, the visitor would return to the guard house.",
                        "The guard would collect the visitor pass and check the visitor out of the system.",
                        "The visitor would then exit the premises.",
                    ])}
                </div>
            </p>
        </p>
    </>,
}

export const ImageDesc123 = {
    title: "Image 123: Schematic of a Public Address System.",
    para1: <>
        <p>The image is a diagram of a public address system which is a wireless network that transmits messages to a large number of receivers at the same time. The components of the diagram are as follows:
            <div className="figure_desc">
                {generateUnOrderedList([
                    <><span style={sectionStyle}>Desktop Paging: </span>
                        This refers to a paging transmitter that is placed on a desk or countertop.
                    </>,
                    <><span style={sectionStyle}>Paging Gateway: </span>
                        This device connects the paging system to a phone network or other external communication system.
                    </>,
                    <><span style={sectionStyle}>Paging Endpoint: </span>
                        This is the device that receives the pages. It can be a phone, an announcement system or another type of device.
                    </>,
                    <><span style={sectionStyle}>Group 1, Group 2: </span>
                        These labels likely refer to different groups of announcement systems that can be called at the same time.
                    </>,
                    <><span style={sectionStyle}>Wifi Access Point: </span>
                        this refers to a Wifi transmitter which may further be connected to an iPhone paging head.
                    </>
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc124 = {
    title: "Image 124: Example of Machine for RFID Access Control. ",
    para1: "The image shows a person holding an Radio-Frequency Identification (RFID) card in their hand, close to an RFID reader. An RFID reader is a device that uses Radio waves to communicate with an RFID tag or card.",
}

export const ImageDesc125 = {
    title: "Image 125: Example of Machine for Biometric Fingerprinting Access Control. ",
    para1: "The image shows a biometric control device with a person's thumb extended to scan the thumbprint.  A biometric device is a security identification and authentication device that is used to ensure that only authorised personnel are allowed into secured private areas. ",
}

export const ImageDesc126 = {
    title: "Image 126: Example of Machine for IRIS Access Control.",
    para1: "The image shows an IRIS access control device with a person in front of it getting scanned for entry. The IRIS is used to control the entry and exit of individuals within a designated area of a designated premise. ",
}

export const ImageDesc127 = {
    title: "Image 127: Representation of a Video Management System. ",
    para1: <>
        <p>The image shows a diagram of a Video Management System (VMS)with the following elements:
            <div className="figure_desc">
                {generateUnOrderedList([
                    <><b>“VMS” </b>(at the center of the diagram) which is denoted with a monitor and a CPU system</>,
                    <><b>"INTEGRATE" </b>(to the top of the diagram) which is denoted with an access control device such as the one on ATM panels. This shows a list of three things that can be integrated with a VMS:
                        {getCircleTypeListItem([
                            "Access Control",
                            "Alarms",
                            "More (This likely refers to other security systems)",
                        ])}
                    </>,
                    <><b>TRIGGER automated Security Devices” </b>(to the top right of the diagram) which is denoted with a speaker and an alarm light.
                    </>,
                    <><b>“MANAGE Multiple Sites & Servers” </b>(to the bottom right of the diagram) which is denoted by several buildings and devices.
                    </>,
                    <><b>“ANALYZE TRANSACTIONS & POINT-OF-SALE DATA ” </b>(to the bottom center of the diagram) which is denoted by a device that looks like an old time wired telephone or a fax machine. </>,
                    <><b>“BACK UP DATA ON LOCAL SERVER” </b>on the bottom left of the diagram which is denoted with diagrams of servers.</>,
                    <><b>"RECORD VIDEO FROM YOUR PHONE TO YOUR SERVER" </b> (at the top left of the diagram) which is denoted by a blue phone with a rounded edge sits on top of a black server.</>,
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc128 = {
    title: "Image 128: Example of an IP Surveillance System.",
    para1: "The image shows a person sitting in front of multiple television screens which shows images from various spaces indicating the surveillance footage from CCTV cameras in a certain building.",
}

export const ImageDesc129 = {
    title: "Image 129:  Example of Digital Mass Notification System for guiding emergency evacuation. ",
    para1: `The image shows a screen with a sign that says "Emergency Alert System Alert! Vacate the Building". The image is an example of a digital mass notification system in emergency situations.`,
}

export const ImageDesc130 = {
    title: "Image 130: Example of a Mass Notification System.",
    para1: "The image shows multiple screens that are used to give mass notification. The image shows 6 screens on a white wall with text on each of the screens. ",
}

export const ImageDesc131 = {
    title: "Image 131: Example of an accessible information kiosk.",
    para1: "The image shows an example of a court check-in kiosk. It has a touch screen that allows people to interact with the system.",
}

export const ImageDesc132 = {
    title: "Image 132: Example of a Mass Notification System and Accessible Interactive Self-Service Kiosks.",
    para1: " The image shows two kiosks and a television mounted on a wall. The kiosks are used for self-service check-in, while the television may be used to display informational content.",
}

export const ImageDesc133 = {
    title: "Image 133: Representative Image of a Server Room.",
    para1: "The image shows a row of servers in a brightly lit room with white tiles. The servers are tall and black metal boxes. Each server has a blinking light on the front.",
}

export const ImageDesc134 = {
    title: "Image 134: Representative Image of a Strong Room/Bunker.",
    para1: "The image is a drawing of a Strong Room or a Bunker with a door. The building appears to be made out of concrete blocks. It has a rectangular shape with a flat roof. There is a metal door on the front of the building. The text at the top of the image says “Godden Sudik Safe Room”. The image shows the layers of building materials used to build the Safe Room."
}

export const ImageDesc135 = {
    title: "Image 135: Example of a Lead Protection System. ",
    para1: "The image shows a portable Lead Protection System held by a person. The image shows two versions of the system, i.e., when it is folded as well as when it is opened. The Lead Protection System is made of a black material.",
}

export const ImageDesc136 = {
    title: "Image 136: Reverberation time target in relation to Space volume.",
    para1: <>
        <p>The image is a graph of the volume of sound in cubic meters (m³) for different types of music according to DIN 18041, a German standard for acoustics.</p>
        <p>The breakdown of the information on the graph is as follows:
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        The x-axis shows the volume in cubic meters (m³).
                        {getCircleTypeListItem([
                            "The progression on the axis starts from 30 m³ and goes to 100 to 500 to 1000 to 5000 to 10000 to 30000 (m³). ",
                        ])}
                    </>,
                    <>
                        The y-axis shows the Target[T] in seconds (s).
                        {getCircleTypeListItem([
                            "The progression on the axis starts from 0 seconds and proceeds with progression of 0.2 s upto 2.4 s. ",
                        ])}
                    </>,
                    <>
                        The progression of the plotted lines is as follows:
                        {getCircleTypeListItem([
                            <>Plot A1 is the plot for Music (red line){getSquareTypeListItem([
                                "Starts between 0.6s and 0.8s on the y-axis and 30 m³ on the x-axis",
                                "The solid line stops at 1.4s on the y-axis and 1000 m³ on the x-axis",
                                "Rest of the progression is a dotted line to the end of the graph on the same tangent",
                            ])}</>,
                            <>Plot A2 is the plot for Speech/Lecture (light blue line){getSquareTypeListItem([
                                "Starts at 0.5s on the y-axis and 50 m³ on the x-axis",
                                "The solid line stops at just above 1.2s on the y-axis and 5000 m³ on the x-axis",
                                "Rest of the progression is a dotted line to the end of the graph on the same tangent",
                            ])}</>,
                            <>Plot A3 is the plot for Teaching/Communication (green line){getSquareTypeListItem([
                                "Starts at 0.3s on the y-axis and 30 m³ on the x-axis",
                                "The solid line stops at 1.0s on the y-axis and 5000 m³ on the x-axis",
                                "Rest of the progression is a dotted line to the end of the graph on the same tangent",
                            ])}</>,
                            <>Plot A4 is the plot of Teaching/Communication Inclusion (purple line){getSquareTypeListItem([
                                "Starts a little over 0.2 on the y-axis and 30 m³ on the x-axis",
                                "The solid line stops at between 0.5s and 0.6s on the y-axis and 500 m³ on the x-axis",
                                " Rest of the progression is a dotted line to the end of the graph on the same tangent",
                            ])}</>,
                            <>Plot A5 is the plot of Sport (dark blue line){getSquareTypeListItem([
                                "Starts 0.7s and 0.8s on the y-axis and 200 m³ on the x-axis",
                                "The solid line plateaus at 2.0s on the y-axis 10000 m³ on the x-axis",
                                "Rest of the progression is a solid line that plateaus at 2.0s to the end of the graph till 30000 m³",
                            ])}</>,

                        ])}
                    </>,
                ])}
            </div>
        </p>
        <p>Overall, the graph suggests that the volume standards set by DIN 18041 allow for higher sound levels for sports followed by music and then other activities such as speech or lectures.</p>
    </>,
}

export const ImageDesc137 = {
    title: "Image 137:  Example of perforated wooden/laminate acoustic panel (left) and slotted wooden/laminated acoustic panel (right).",
    para1: "The image has two examples of perforated walls, i.e., wooden walls with holes in them. The picture on the right also has a black bench in front of it. The image on the left is just of the perforated walls. The walls are light colored wood and have a smooth surface. Such walls are used in a space to ensure better acoustics as per the needs of the space.",
}

export const ImageDesc138 = {
    title: "Image 138: Example of mineral fibre ceiling tiles (left) and perforated gypsum tile ceiling (right).",
    para1: "The image shows a picture of mineral fibre ceiling tiles on the left and perforated (with holes) gypsum ceiling tiles on the right. Such ceiling tiles are used in a space to ensure better acoustics as per the needs of the space. Both the ceilings shown in the pictures are white in colour.",
}

export const ImageDesc139 = {
    title: "Image 139: Example of fibre-reinforced perforated gypsum wall panelling (left) and perforated acoustic metal ceiling tiles (right).",
    para1: "The image shows a picture of a fibre-reinforced perforated (with holes) gypsum wall panelling on the left and perforated acoustic metal ceiling tiles on the right. Such ceiling tiles are used in a space to ensure better acoustics as per the needs of the space. Both the ceilings shown in the pictures are white in colour.",
}

export const ImageDesc140 = {
    title: "Image 140: Examples of common sources of noise.",
    para1: <>
        <p>This image is a diagram illustrating sound transmission in buildings. The sounds are being described in a semi-clockwise manner:
            <div className="figure_desc">
                {generateUnOrderedList([
                    `To the very left side of the diagram, there is a person standing. The sounds originating from them include “sound transmissions” from them and “electrical noises” `,
                    `Sound may also be generated from any movement from the “Floors & Ceilings” below the room `,
                    `There are two persons sitting in the middle of the diagram who may also be sources for some noises.`,
                    <>
                        The sources of noise from the right-most part of the diagram which is the back of the room being depicted include:
                        {getCircleTypeListItem([
                            `“Unit Ventilators” `,
                            `“Cracks”`,
                            `“Flanking Noise” `,
                            `Windows/Exterior Walls”`,
                        ])}
                    </>,
                    <>
                        The sources of noise that may come from the top of the room depicted in the diagram include:
                        {getCircleTypeListItem([
                            `“HVAC Noise”`,
                            `“Duct Noise”`,
                            `“Diffuser”`,
                            `Noise from “Roofs”/“Floors & Ceilings” (depending on where the room is situated in the building)`,
                            `“Light Fixtures”`,
                        ])}
                    </>,
                ])}
            </div>
        </p>

    </>,
}

export const ImageDesc141 = {
    title: "Image 141: Emergency Messaging and Alerts for digital signage.",
    para1: "The image you sent me shows a hallway with a sign showing a digital emergency message. The sign states “Fire at Court 1” and “Please head to your nearest Exit” with an arrow pointing in the direction of the nearest exit."
}

export const FigureDesc77 = {
    title: "Figure 77: Floorplan of a Courtroom with the layout for material recommendations for the Courtroom walls.",
    para1: <>
        <p>
            The figure shows the placement of acoustically treated materials on the Courtroom walls. The Courtroom floor plan used is the plan described in Figure 36.
        </p>
        <p>
            The entire Courtroom is divided into two areas: “Moderate Sound Absorption” and “High Sound Absorption”. The area in which materials that have moderate sound absorption should be used is the back of the Courtroom where the general public is seated. The area in which materials that have high sound absorption should be used includes the Judges’ dias up to the area in which the lawyers’ table is located.  The key to the figure is given on the bottom right of the plan.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">

                {generateUnOrderedList([
                    "The wall between the access doors is an acoustic material having 0.75 NRC. This wall is behind the gallery of the Courtroom.",

                    "The left and right walls of the Courtroom is divided between accoustic material having 0.75 NRC up to the area which is the area for the general public and accoustic reflective material from the area where the lawyers’ table is placed.",

                    "The wall behind the Judges dias is accoustically reflective material.",

                    "The wall beside the ramp is accoustically reflective material.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc78 = {
    title: "Figure 78: Floorplan of a Courtroom with the layout for material recommendations for the Courtroom ceiling. ",
    para1: <>
        <p>The figure shows 0.75 - 0.9 NRC acoustic ceiling material recommendation for Courtroom ceiling. The material has been shown in the form of a red rectangular box imposed on top of the plan for the Courtroom as described in Figure 36 of this Handbook. I.e., it shows how acoustically treated materials should be fixed to the ceiling of a Courtroom to make it acoustically effective. The plan also shows a similar rectangular box on top of the Court Clerk’s Room which is adjacent to the Courtroom showing the position of the acoustically treated materials on the room’s ceiling.</p>
        <p>The key at the bottom right corner of the figure gives a key stating that the ceiling for both rooms are  NRC Acoustic ceilings. </p>
    </>
}


